import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"; // Added Link import
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import axios from "axios";
import styles from "./AboutPage.module.css";

// --- DEFAULT LOCAL IMAGES ---
import defaultStory1 from "../assets/About us/women-gatta.jpg";
import defaultStory2 from "../assets/About us/roasting.jpg";
import defaultKorma from "../assets/About us/dukamo-korma.jpg";

function AboutPage() {
  const [content, setContent] = useState({ textFields: {}, imageFields: {} });

  useEffect(() => {
    window.scrollTo(0, 0);
    // Fetch CMS Content
    axios
      .get("/api/pages/about")
      .then((res) => {
        if (res.data) setContent(res.data);
      })
      .catch((err) => console.log("Using default content"));
  }, []);

  // --- HELPER 1: GET TEXT ---
  const getText = (key, fallback) => {
    return content.textFields && content.textFields[key]
      ? content.textFields[key]
      : fallback;
  };

  // --- HELPER 2: GET IMAGE ---
  const getImage = (key, fallback) => {
    if (content.imageFields && content.imageFields[key]) {
      return `${content.imageFields[key]}`;
    }
    return fallback;
  };

  return (
    <div className={styles.aboutPage}>
      <Navbar />

      {/* ORIGINAL WHITE HEADER */}
      <div className={styles.aboutHeader}>
        <h1>{getText("heroTitle", "About Us")}</h1>
      </div>

      {/* DARK LUXURY BODY */}
      <div className={styles.aboutSectionContainer}>
        {/* --- STORY SECTION --- */}
        <section className={styles.aboutStory}>
          <h2>{getText("storyTitle", "Our Story")}</h2>

          <p style={{ whiteSpace: "pre-line" }}>
            {getText("storyText", "Dukamo Coffee was born from a passion...")}
          </p>

          <div className={styles.storyImages}>
            {/* Image 1 Container */}
            <div className={styles.storyImageContainer}>
              <img
                src={getImage("storyImage1", defaultStory1)}
                alt="Women Gatta"
              />
              <p className={styles.imageCaption}>Women in Gatta Station</p>
            </div>

            {/* Image 2 Container */}
            <div className={styles.storyImageContainer}>
              <img
                src={getImage("storyImage2", defaultStory2)}
                alt="Roasting Process"
              />
              <p className={styles.imageCaption}>Roasting</p>
            </div>
          </div>

          {/* --- NEW SECTION: COFFEE OF THE WEEK --- */}
          <div className={styles.cotwTeaser}>
            <h3>Coffee Of The Week</h3>
            <p>
              Explore our curated selection of exceptional coffees from around
              the globe. Every week we highlight roasters who bring global
              flavors to your cup.
            </p>
            <Link to="/coffee-of-the-week">
              <button className={styles.cotwButton}>View Selection</button>
            </Link>
          </div>
        </section>

        {/* --- VALUES SECTION --- */}
        <section className={styles.aboutValues}>
          <h2>Values</h2>
          <ul>
            <li>Connecting People Through Coffee</li>
            <li>Blending Tradition with Innovation</li>
            <li>Investing in People</li>
            <li>Driven by Passion</li>
            <li>Rooted in Ethiopian Legacy</li>
          </ul>
        </section>

        {/* --- FOUNDER SECTION --- */}
        <section className={styles.aboutKorma}>
          <div className={styles.kormaImage}>
            <img
              src={getImage("kormaImage", defaultKorma)}
              alt="Dukamo Korma"
            />
          </div>
          <div className={styles.kormaText}>
            <h2>{getText("kormaTitle", "Dukamo Korma (ADARA)")}</h2>
            <p style={{ whiteSpace: "pre-line" }}>
              {getText(
                "kormaText",
                "Named in honor of our beloved grandfather..."
              )}
            </p>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default AboutPage;
